<template>
  <div class="goods1">
    <div class="mb20">
      点击删除按钮可以对其置空，点击添加按钮可以添加商品，商品可以拖动排序。图片像素推荐24*24像素。
    </div>
    <el-form :model="currentInfo" label-width="60px">
      <el-form-item label="标题">
        <el-input placeholder="请输入标题" v-model="currentInfo.title" />
      </el-form-item>
      <el-form-item label="图片">
        <el-upload
          :action="fileObj.url"
          :before-upload="beforeUpload"
          :on-success="successUpdate"
          :headers="reqData"
          :show-file-list="false"
        >
          <img
            class="list-img"
            v-if="currentInfo.picture"
            :src="currentInfo.picture"
            @click="updateImg()"
          />
          <i class="el-icon-plus" v-else />
        </el-upload>
      </el-form-item>
    </el-form>
    <draggable
      v-model="currentInfo.wxSchoolPageItemList"
      @update="datadragEndContent"
      :options="{ animation: 500 }"
    >
      <div
        v-for="(item, index) in currentInfo.wxSchoolPageItemList"
        :key="index"
      >
        <div
          class="flex jc-sb cp wx-item-style"
          @click="addGoodSingleBtn(index)"
          style="height: 49px"
        >
          <div class="ellipsis">
            {{ item.schoolPageInfo.name }}
          </div>
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="mini"
            @click.stop="deleteBtn(index)"
            v-if="item.relationId"
          ></el-button>
          <el-button type="primary" v-else size="mini">添加</el-button>
        </div>
      </div>
    </draggable>
  </div>
</template>
<script>
import { codeMixin } from "../../../minix";
export default {
  mixins: [codeMixin],
  methods: {
    deleteBtn(index) {
      this.$confirm("确认删除？")
        .then((_) => {
          this.currentInfo.wxSchoolPageItemList[index].isEmpty = 1;
          this.currentInfo.wxSchoolPageItemList[index].relationId = "";
          this.currentInfo.wxSchoolPageItemList[index].schoolPageInfo = {};
        })
        .catch((_) => {});
    },
    //选单个
    addGoodSingleBtn(index) {
      this.$store.commit("design/SET_ADDDIALOGVISIBLE", {
        addDialogVisible: true,
        single: true,
        singleIndex: index,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.goods1 {
  /deep/ .el-upload {
    width: 100px;
    height: 100px;
    border: 1px dashed rgb(196, 192, 192);
    display: flex;
    border-radius: 6px;
    align-items: center;
    justify-content: center;
    .el-icon-plus {
      font-size: 36px;
    }
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: cover;
    }
  }
  .jc-sb {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    margin-top: 10px;
    border-radius: 6px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/designPage/template/goods/goods1/setting.vue